import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-dark-section text-on-dark grain-overlay py-20 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="h-14 w-14 grid place-items-center bg-white/95 rounded-md">
              <img
                src="/cesars-logo.png"
                alt="Cesar's Repairs"
                className="h-11 w-11 object-contain"
              />
            </span>
            <p className="font-display text-lg font-medium">Cesar's Repairs</p>
          </div>
          <p className="mt-4 text-sm text-white/70 max-w-sm leading-relaxed">
            {t.footer.tagline}. Mont-Royal, Quebec.
          </p>
          <a
            href="tel:+14388743855"
            data-testid="footer-phone-link"
            className="mt-6 inline-block font-display text-2xl hover:text-[#E8A58B] transition-colors"
          >
            +1 (438) 874-3855
          </a>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] text-white/50">
            {t.footer.nav}
          </p>
          <ul className="mt-4 space-y-3 text-sm">
            <li><a href="#services" className="hover:text-[#E8A58B] transition-colors">{t.nav.services}</a></li>
            <li><a href="#about" className="hover:text-[#E8A58B] transition-colors">{t.nav.about}</a></li>
            <li><a href="#quote" className="hover:text-[#E8A58B] transition-colors">{t.nav.quote}</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] text-white/50">
            {t.footer.hours}
          </p>
          <ul className="mt-4 space-y-2 text-sm">
            {t.hours.rows.map(([day, hours], i) => (
              <li key={i} className="flex items-center justify-between gap-4">
                <span className="text-white/90">{day}</span>
                <span className={hours === "Closed" || hours === "Fermé" ? "text-[#E8A58B]" : "text-white/70"}>{hours}</span>
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs uppercase tracking-[0.2em] text-white/50">
            {t.footer.reach}
          </p>
          <p className="mt-3 text-sm text-white/80 leading-relaxed">
            {t.contact.address}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
        <p>© {year} Cesar's Repairs. {t.footer.rights}</p>
        <p>RBQ 5795-0118-01 · Mont-Royal, QC · Canada</p>
      </div>
    </footer>
  );
};
